export default __webpack_public_path__ + "static/media/close.9ad5654c.svg";